module.exports = __webpack_public_path__ + "img/bh.891539ac.svg";